<template>
    <asli-form-section title="Personal Details" heading-level="h4">
        <asli-radio
            :id="buildId('title')"
            :name="buildId('title')"
            rules="required:title"
            v-model="data.personal_details.title"
            label="Title"
            :options="lists?.title"
        />
        <asli-text-input
            :id="buildId('first_name')"
            :name="buildId('first_name')"
            rules="required:first_name_jp"
            v-model="data.personal_details.first_name"
            label="First Name"
            large
            is-capitalized
            :mask="NAME_MASK_ANPOST"
        />
        <asli-text-input
            :id="buildId('surname')"
            :name="buildId('surname')"
            rules="required:last_name_jp"
            v-model="data.personal_details.surname"
            label="Last Name"
            large
            is-capitalized
            :mask="NAME_MASK_ANPOST"
        />
        <asli-date
            :id="buildId('date_of_birth')"
            :name="buildId('date_of_birth')"
            rules="required:date_of_birth_jp"
            label="Date of Birth"
            v-model="data.personal_details.date_of_birth"
            initial-mode="year"
            :date-from="{ date: oldestAge, message: oldestAgeValidationMessage }"
            :date-to="{ date: youngestAge, message: youngestAgeValidationMessage }"
            calendar-aria-label="Open calendar to select their date of birth"
            :show-today="false"
            no-margin
        />
    </asli-form-section>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import {
    AsliFormSection,
    AsliDate,
    AsliRadio,
    AsliTextInput,
    getDateMinusYears,
    NAME_MASK_ANPOST
} from "@mbs-npm/anpost-ui";
import { PropType, reactive, watch } from "vue";
import { useListStore } from "@/stores/lists/lists";
import { JointProposer } from "@/stores/risk/types/drivers/driver-types";
import { capitalizeName } from "@/utils";

const props = defineProps({
    index: { type: Number, required: true },
    item: {
        type: Object as PropType<JointProposer>,
        required: true
    }
});

const emit = defineEmits<{ (e: "update", val: JointProposer): void }>();

const listStore = useListStore();
const lists = computed(() => listStore?.lists);

const data = reactive<JointProposer>({
    personal_details: {
        title: props.item.personal_details.title,
        first_name: props.item.personal_details.first_name,
        surname: props.item.personal_details.surname,
        date_of_birth: props.item.personal_details.date_of_birth
    }
});

const buildId = (id: string) => `proposer_${props.index}_${id}`;

const oldestAge = computed(() => getDateMinusYears(100));
const youngestAge = computed(() => getDateMinusYears(18));

const oldestAgeValidationMessage = "Joint policyholder must be under 100 years of age.";
const youngestAgeValidationMessage = "Joint policyholder must be at least 18 years of age.";

watch(data, newData =>
    emit("update", {
        ...newData,
        personal_details: {
            ...newData.personal_details,
            first_name: capitalizeName(newData.personal_details.first_name ?? ""),
            surname: capitalizeName(newData.personal_details.surname ?? "")
        }
    })
);
</script>
